export default __webpack_public_path__ + "static/media/guesty_step4.3f5e4b2d.png";